// extracted by mini-css-extract-plugin
export default {"debtClass":"ProjectDebtClass_debtClass__R4A3q"};